import { UndefinedContent, type XYChartState } from '../types/state.js';
import {
  DOT_VARIANT,
  RECT_VARIANT,
  type DotSeriesWithDatapoints,
  type RectDatapointInternal,
  type RectSeriesWithDatapoints,
} from '../types/xy-chart-internals.js';
import type { DotDatapoint } from '../types/xy-chart.js';

export function reduceDotTooltipContent(
  dot: DotDatapoint,
  series: DotSeriesWithDatapoints,
): (prev: XYChartState) => XYChartState {
  return (prev: XYChartState): XYChartState => ({
    ...prev,
    explore: {
      ...prev.explore,
      content: {
        datapoint: dot,
        series: series,
        type: DOT_VARIANT,
      },
    },
  });
}

export function reduceRectTooltipContent(
  rect: RectDatapointInternal,
  series: RectSeriesWithDatapoints,
): (prev: XYChartState) => XYChartState {
  return (prev: XYChartState): XYChartState => ({
    ...prev,
    explore: {
      ...prev.explore,
      content: {
        datapoint: rect,
        series: series,
        type: RECT_VARIANT,
      },
    },
  });
}

export function reduceUndefinedTooltipContent(
  prev: XYChartState,
): XYChartState {
  return {
    ...prev,
    explore: {
      ...prev.explore,
      content: UndefinedContent,
    },
  };
}
